/**
 *
 * DocumentNavigation
 *
 */

import React from 'react';
import clsx from 'clsx';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FormattedMessage } from 'lib/intl';

// api
import { Invoice } from 'lib/api/invoice';
import { generateImageURL } from 'lib/api/images';

// ui
import { Text, Button, Flex } from '@domonda/ui';
import { EditIcon } from 'lib/domonda-icons';

// decorate
import { decorate, Decorate } from './decorate';

export interface DocumentNavigationProps {
  onActivateSplit: () => void;
  invoices: Invoice[];
  selectedInvoiceIndex: number;
  onChangeSelectedInvoiceIndex: (index: number) => void;
}

const DocumentNavigation: React.FC<DocumentNavigationProps & Decorate> = (props) => {
  const {
    classes,
    invoices,
    selectedInvoiceIndex,
    onChangeSelectedInvoiceIndex,
    onActivateSplit,
  } = props;

  return (
    <Flex container direction="column" fill>
      <Flex item>
        <div className={classes.splitterContainer}>
          <Button color="primary" onClick={onActivateSplit}>
            <EditIcon />
            <span>
              <FormattedMessage id="DOCUMENT_DETAIL_EDIT" />
            </span>
          </Button>
        </div>
      </Flex>
      <Flex item flex={1}>
        <AutoSizer>
          {({ width, height }) => (
            <List
              width={width - 1 /* subtract 1px to prevent showing horizontal scrollbar */}
              height={height}
              itemSize={336}
              itemCount={invoices.length}
            >
              {({ index, style }) => (
                <div
                  key={`${invoices[index].InvoiceId}-invoice-thumb-${index}`}
                  className={classes.thumbsInvoice}
                  style={style}
                >
                  <div
                    className={clsx(
                      classes.thumbsInvoiceInner,
                      selectedInvoiceIndex === index
                        ? classes.thumbsInvoiceInnerSelected
                        : classes.thumbsInvoiceInnerClickable,
                    )}
                    role="button"
                    onClick={
                      selectedInvoiceIndex !== index
                        ? () => onChangeSelectedInvoiceIndex(index)
                        : undefined
                    }
                  >
                    <Text variant="subtitle" font="header">
                      <FormattedMessage id="DOCUMENT_DETAIL_INVOICE" />
                      &nbsp;#{index + 1}
                    </Text>

                    <Text color="textSecondary" gutterBottom>
                      <FormattedMessage id="DOCUMENT_DETAIL_PAGES" />
                      :&nbsp;<strong>{invoices[index].Pages.length}</strong>
                    </Text>

                    <div className={classes.thumbsInvoicePage}>
                      <img
                        src={generateImageURL(invoices[index].Pages[0].PreviewSrc)}
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              )}
            </List>
          )}
        </AutoSizer>
      </Flex>
    </Flex>
  );
};

const ComposedDocumentNavigation = decorate(DocumentNavigation);
export { ComposedDocumentNavigation as DocumentNavigation };
